module.exports = __webpack_public_path__ + "static/media/Group 11555.2925c09b.svg";